<script setup>
import { inject } from 'vue';

const store = inject('store');
</script>

<template>
  <router-link to="/" class="navbar-brand text-light">
    <span class="fs-3 fw-bold">{{ store.state.brand.part1 }}<span class="text-bisque">{{ store.state.brand.part2 }}</span>{{ store.state.brand.part3 }}
    </span>
  </router-link>

  <div class="d-flex flex-column text-uppercase text-secondary">
    <span class="fs-3 fw-bold">{{ store.state.brand.caption }}</span>
    <span class="fs-6">{{ store.state.brand.levels }}</span>
  </div>
</template>